import { type Action, createHook, createStore } from 'react-sweet-state';

import {
	type AppConfigStoreState as AppConfigStoreState,
	type TeamsClientConfig,
	type TeamsNavigationConfig,
	type TeamsProductConfig,
} from '../types';

const defaultNavigationState: TeamsNavigationConfig = {
	contextSpaPaths: [],
	contextEntryPoint: null,
};

const defaultClientConfigState: TeamsClientConfig = {
	cloudId: null,
	stargateRoot: '',
	env: undefined,
};

const defaultTeamsProductConfigState: TeamsProductConfig = {
	appName: null,
	productName: null,
	isJiraAvailable: false,
};

const defaultState: AppConfigStoreState = {
	...defaultNavigationState,
	...defaultClientConfigState,
	...defaultTeamsProductConfigState,
	docTitle: {},
};

const actions = {
	setNavigationConfig:
		(navigationConfig: TeamsNavigationConfig): Action<AppConfigStoreState> =>
		({ setState }) => {
			setState({
				...navigationConfig,
			});
		},
	setClientConfig:
		(clientConfig: TeamsClientConfig): Action<AppConfigStoreState> =>
		({ setState }) => {
			setState({
				...clientConfig,
			});
		},
	setTeamsProductConfig:
		(teamsProductConfig: TeamsProductConfig): Action<AppConfigStoreState> =>
		({ setState }) => {
			setState({
				...teamsProductConfig,
			});
		},
	// Set all config at once
	setAppConfig:
		(appConfig: AppConfigStoreState): Action<AppConfigStoreState> =>
		({ setState }) => {
			setState({
				...appConfig,
			});
		},
};

type AppConfigActions = typeof actions;

const AppConfigStore = createStore<AppConfigStoreState, AppConfigActions>({
	initialState: defaultState,
	actions,
});

export const useAppConfigStore = createHook(AppConfigStore);
const useAppConfigActions = createHook(AppConfigStore, { selector: null });

export const useAppConfigStoreState = () => useAppConfigStore()[0];

export const useSetTeamsConfigActions = () => {
	return useAppConfigActions()[1];
};

export const useAppName = () => useAppConfigStoreState().appName;

export const useNavigationState = () => {
	const { contextSpaPaths, contextEntryPoint } = useAppConfigStoreState();
	return { contextSpaPaths, contextEntryPoint };
};
